import { TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { MenuTriggerDirectiveModule } from '@adaptiva/core/menus';
import { SerializedPropertyMapPipe } from '@adaptiva/metadata/common';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { BrowserComponentModule } from '@adaptiva/widgets/browser';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CheckboxComponentModule } from '@adaptiva/widgets/checkbox';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { ExpressionLanguageEditorModule } from '@adaptiva/widgets/expression-editor';
import { IconComponent } from '@adaptiva/widgets/icon';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, PipeTransform, Type } from '@angular/core';
import { AuthoringRuleComponent } from './authoring-rule.component';
import { IsParentTypePipe, RuleIconPipe } from './pipes';

const DIRECTIVES: Type<any>[] = [
	MenuTriggerDirectiveModule,
	TemplateMarkerDirectiveModule
];

const PIPES: Type<PipeTransform>[] = [
	IsParentTypePipe,
	RuleIconPipe,
	SerializedPropertyMapPipe,
];

const WIDGETS: Type<any>[] = [
	AlertComponentModule,
	BrowserComponentModule,
	ButtonComponentModule,
	CheckboxComponentModule,
	ComboComponentModule,
	ContainerComponentModule,
	ExpressionLanguageEditorModule,
	IconComponent,
	InputComponentModule,
	LabelComponentModule,
	MenuComponentModule,
	OverlayComponentModule,
	TextComponentModule,
];

@NgModule({
	imports: [
		CommonModule,
		DIRECTIVES,
		PIPES,
		WIDGETS
	],
	declarations: [AuthoringRuleComponent],
	exports: [AuthoringRuleComponent]
})
export class AuthoringRuleComponentModule {

}
